import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RatingsPage } from '@/features/ratings/pages/ratings-page';

const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** Enterprise ratings dashboard; range and comment filter live in the URL (default: this month, everything). */
export const Route = createFileRoute('/_app/ratings')({
  validateSearch: z.object({
    from: day.optional().catch(undefined),
    to: day.optional().catch(undefined),
    filter: z.enum(['all', 'low', 'unresolved']).optional().catch(undefined),
  }),
  component: RatingsPage,
});
